import { Tabs } from "@mantine/core";
import { useNavigate } from "react-router";

export type TeamTab = "people" | "roles";

const PATHS: Record<TeamTab, string> = {
  people: "/team",
  roles: "/team/roles",
};

/** Team's tabs: who has a login and what they hold, then the roles themselves. */
export function TeamTabs({ active }: { readonly active: TeamTab }) {
  const navigate = useNavigate();
  return (
    <Tabs
      value={active}
      onChange={(value) => {
        if (value !== null && value in PATHS) void navigate(PATHS[value as TeamTab]);
      }}
      mb="lg"
    >
      <Tabs.List>
        <Tabs.Tab value="people">Team members</Tabs.Tab>
        <Tabs.Tab value="roles">Roles</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
